<template>
  <v-row v-if="!appLoading">
    <v-col class="pt-0 pt-sm-3">
      <v-card>
        <v-card-title> Categories </v-card-title>
        <v-card-text>
          <v-row class="align-center justify-right">
            <v-col
              cols="6"
              md="3"
            >
              <search-field
                v-model="categorySearch"
                autofocus
              />
            </v-col>
            <v-col
              cols="6"
              md="9"
              class="text-right"
            >
              <add-new-button
                @click="
                  selectedCategories = [{}]
                  editCategoryDialog = true
                "
              />
            </v-col>
          </v-row>

          <v-data-table
            v-model="selectedCategories"
            :headers="categoryHeaders"
            :items="appTemplateCategories"
            :search="categorySearch"
            :sort-by="['name']"
            hide-default-footer
            item-key=".key"
            @click:row="(item) => (selectedCategories = [item])"
          >
            <template #[`item.name`]="{ item }">
              <a @click="editCategoryDialog = true">{{ item.name }}</a>
            </template>

            <template #[`item.accountTypes`]="{ item }">
              {{ accountTypeLabels(item.accountTypes) }}
            </template>

            <template #[`item.created`]="{ item }">
              <v-tooltip bottom>
                <template #[`activator`]="{ on }">
                  <span v-on="on">{{ $formatFsTimestamp(item.created) }}</span>
                </template>
                <span>{{
                  item.created && item.created.toDate().toLocaleString()
                }}</span>
              </v-tooltip>
            </template>

            <template #[`item.modified`]="{ item }">
              <v-tooltip bottom>
                <template #[`activator`]="{ on }">
                  <span v-on="on">{{ $formatFsTimestamp(item.modified) }}</span>
                </template>
                <span>{{
                  item.modified && item.modified.toDate().toLocaleString()
                }}</span>
              </v-tooltip>
            </template>

            <template #[`item.active`]="{ item }">
              <v-checkbox
                v-model="item.active"
                readonly
                disabled
              />
            </template>

            <div>
              <v-icon
                small
                @click="editCategoryDialog = true"
              >
                mdi-pencil
              </v-icon>
            </div>
          </v-data-table>

          <v-dialog
            v-model="editCategoryDialog"
            scrollable
            max-width="500px"
          >
            <edit-category
              :selected-category="selectedCategory"
              :lawyers="lawyers"
              :app-template-categories="appTemplateCategories"
              @cancel="editCategoryDialog = false"
              @categorySaved="editCategoryDialog = false"
            />
          </v-dialog>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col v-if="selectedCategory">
      <templates-template-list
        allow-category-selection
        :title="templateListTitle"
        :templates="templatesForCategory"
        :categories="appTemplateCategories"
        :new-template-defaults="newTemplateDefaults"
      />
    </v-col>
  </v-row>
</template>

<script>
import AddNewButton from './AddNewButton.vue'
import EditCategory from './EditCategory.vue'
import SearchField from './SearchField.vue'
import TemplatesTemplateList from './TemplatesTemplateList.vue'

import { getAccountType } from '@/dataAccess/accountTypes'
import { listLawyers } from '@/dataAccess/users'
import { getId, isNewRecord } from '@/dataAccess/queries'
import { listTemplateCategories, listTemplates } from '@/dataAccess/templates'

const categoryHeaders = [
  { text: 'Name', value: 'name', align: 'left' },
  { text: 'Account types', value: 'accountTypes', align: 'left' },
  { text: 'Created', value: 'created', align: 'left', sortable: true },
  { text: 'Modified', value: 'modified', align: 'left', sortable: true },
  { text: 'Active', value: 'active', align: 'left', sortable: false },
  { text: ' ', value: 'actions', align: 'center', sortable: false }
]
export default {
  name: 'TemplatesEditCategories',
  components: {
    AddNewButton,
    EditCategory,
    SearchField,
    TemplatesTemplateList
  },
  data: () => ({
    categorySearch: null,
    editCategoryDialog: false,
    categoryHeaders,
    appLoading: true,
    selectedCategories: []
  }),
  computed: {
    newTemplateDefaults() {
      return {
        categories: [getId(this.selectedCategory)]
      }
    },
    templateListTitle() {
      return `"${this.selectedCategory.name}" templates`
    },
    templatesForCategory() {
      if (this.appLoading) {
        return []
      }
      if (isNewRecord(this.selectedCategory)) {
        return []
      }
      const categoryId = getId(this.selectedCategory)
      return this.appTemplates.filter((item) =>
        item.categories.includes(categoryId)
      )
    },
    selectedCategory() {
      return this.selectedCategories.length > 0
        ? this.selectedCategories[0]
        : this.appTemplateCategories[0]
    }
  },
  async mounted() {
    await Promise.all([
      this.$binding('lawyers', listLawyers()),
      this.$binding('appTemplates', listTemplates()),
      this.$binding('appTemplateCategories', listTemplateCategories())
    ])
    this.appLoading = false
  },
  methods: {
    accountTypeLabels(accountTypes = []) {
      return accountTypes
        .map(getAccountType)
        .map(({ label }) => label)
        .join(', ')
    }
  }
}
</script>
